import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    secondaryMainColor: {
      color: palette.secondary.main,
    },
    inputRoot: {
      '&.MuiOutlinedInput-root': {
        paddingTop: 'inherit',
        paddingBottom: 'inherit',

        '& .MuiAutocomplete-input': {
          paddingTop: spacing(1.8),
          paddingBottom: spacing(1.8),
        },
      },
    },
  }),
)
